import React, { useState, useEffect } from 'react';
import '../styles/UpdateNotification.css';

/**
 * UpdateNotification component
 * Displays a banner when a PWA update is available
 * Automatically prompts users to reload and get the latest version
 */
const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    // Listen for service worker updates
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker is installed and waiting
              setShowUpdate(true);
              setRegistration(reg);
            }
          });
        });
      });

      // Also check if there's already a waiting worker
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg && reg.waiting) {
          setShowUpdate(true);
          setRegistration(reg);
        }
      });
    }
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      // Tell the service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Reload when the new service worker takes control
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
    // User dismissed, they'll get prompted again on next page load if update is still available
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div className="update-notification">
      <div className="update-notification-content">
        <div className="update-notification-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <div className="update-notification-text">
          <strong>Update Available</strong>
          <p>A new version of Parish Recorder is ready. Click "Update" to get the latest features.</p>
        </div>
        <div className="update-notification-actions">
          <button onClick={handleUpdate} className="update-btn">
            Update Now
          </button>
          <button onClick={handleDismiss} className="dismiss-btn">
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
